import { render } from "./ForgotPasswordComponent.vue?vue&type=template&id=433b2d4c"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/auth/ForgotPasswordComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "433b2d4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('433b2d4c', __exports__)) {
    api.reload('433b2d4c', __exports__)
  }
  
  module.hot.accept("./ForgotPasswordComponent.vue?vue&type=template&id=433b2d4c", () => {
    api.rerender('433b2d4c', render)
  })

}


export default __exports__